import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {EventText} from '../../../../../commons/components/event-text'
import {Routes} from '../../../../../commons/enums'
import {useCommonDateInformation} from '../../../../../commons/hooks/dates'
import {useMembersPageCurrencyFormatter} from '../../hooks/currency'
import {useMembersPageActions, useMembersPageSelector} from '../../hooks/runtime'
import {getRouteParams} from '../../selectors/navigation'
import {MobileDownloadTicketsButton} from '../actions/mobile-download-tickets-button'
import {Back} from '../back'
import {Divider} from '../styled-components/divider'
import sc from './common.scss'
import s from './mobile-order.scss'
import {Subtotals} from './subtotals'
import {Ticket} from './ticket'

export const MobileOrder = () => {
  const {t} = useTranslation()
  const {order, event} = useMembersPageSelector(getRouteParams)
  const {orderNumber, invoice} = order
  const {items, grandTotal} = invoice
  const {getFormattedMoney} = useMembersPageCurrencyFormatter()
  const total = getFormattedMoney(grandTotal)
  const orderDate = useCommonDateInformation(orderNumber)

  const {internalNavigate} = useMembersPageActions()

  return (
    <div className={s.root}>
      <Back onClick={() => internalNavigate({route: Routes.ORDER_LIST, params: {event}})} t={t} />
      <div className={sc.section}>
        <div>
          <EventText>{t('mobile.order.details.title')}</EventText>
        </div>
        <div className={s.orderNumber} data-hook={DH.MOBILE_ORDER_DETAILS_NUMBER}>
          <EventText faded>{t('mobile.order.number', {orderNumber})}</EventText>
        </div>
        <div className={s.date}>
          <EventText faded>{t('mobile.order.date', {date: orderDate})}</EventText>
        </div>
        <div className={s.total} data-hook={DH.MOBILE_ORDER_DETAILS_TOTAL}>
          <EventText>{t('mobile.order.total', {total})}</EventText>
        </div>
        <div className={s.button}>
          <MobileDownloadTicketsButton event={event} order={order} />
        </div>
      </div>
      <Divider />
      {items.map(item => (
        <Ticket item={item} key={item.id} />
      ))}
      <Subtotals invoice={invoice} />
    </div>
  )
}
